// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"728f6dd3","369":"9d1a5027"}[chunkId] + ".chunk.css";
};